var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer } from "../generators/generator.reducer";
import { brusselsRegistrationRetryStart, brusselsRegistrationRetrySucceeded, brusselsRegistrationRetryFailed, myRentRegistrationRetryStart, myRentRegistrationRetrySucceeded, myRentRegistrationRetryFailed, } from "./rentRegistration.actions";
import { GENERATOR_PARAMS } from "./rentRegistration.constants";
var getDefaultState = function () { return ({
    registrationsById: {},
    myRentRetryResult: undefined,
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getDefaultState);
var reducer = _reducer;
reducer.on(brusselsRegistrationRetryStart.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingBrussels: true, brusselsRetryError: undefined }),
            _b) });
});
// NEED to update the registration also
reducer.on(brusselsRegistrationRetrySucceeded.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingBrussels: false, brusselsRetryError: undefined }),
            _b) });
});
reducer.on(brusselsRegistrationRetryFailed.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId, error = _a.error;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingBrussels: false, brusselsRetryError: error }),
            _b) });
});
reducer.on(myRentRegistrationRetryStart.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: __assign(__assign({}, state.registrationsById), (_b = {}, _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingMyRent: true, myRentRetryError: undefined }), _b)), myRentRetryResult: undefined });
});
reducer.on(myRentRegistrationRetrySucceeded.type, function (state, _a) {
    var _b;
    var registration = _a.registration, registrationId = _a.registrationId;
    return __assign(__assign({}, state), { registrationsById: __assign(__assign({}, state.registrationsById), (_b = {}, _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingMyRent: false, myRentRetryError: undefined }), _b)), myRentRetryResult: registration });
});
reducer.on(myRentRegistrationRetryFailed.type, function (state, _a) {
    var _b;
    var registrationId = _a.registrationId, error = _a.error;
    return __assign(__assign({}, state), { registrationsById: (_b = {},
            _b[registrationId] = __assign(__assign({}, state.registrationsById[registrationId]), { isRetryingMyRent: false, myRentRetryError: error }),
            _b) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
